export default "__VITE_ASSET__BrUK4zV1__"